<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1 top-buffer" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div
          [innerHTML]="
            !!trafficStatus && !hostedEnabled
              ? ('tkey;system_status.zpc.description' | escapeHtml)
              : ('tkey;system_status.zpm.description' | escapeHtml)
          "
        ></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @for (key of statusKeys; track key; let i = $index) {
      <div [hidden]="isLoading" class="status-container">
        @if (key === StatusCategory.ENDPOINTS && !!trafficStatus && trafficStatus?.state !== stateEnum.OK) {
          <div
            class="alert alert-warning d-flex align-items-center justify-content-center p-4"
            data-automation="system-status-result-alert"
          >
            <i class="{{ ziroIcons.WARNING_TRIANGLE }} fa-2x"></i>
            <h5 class="ms-2 mb-0" [innerHTML]="'tkey;system_status.server.unavailable' | escapeHtml"></h5>
          </div>
        }
        <table
          class="status-container__table table table-striped table-hover border-rad-table"
          [ngClass]="getTableBorderClass(formattedStatuses.get(key))"
          [attr.data-automation]="'system-status-' + key.toLowerCase().split(' ').join('-') + '-status-table'"
        >
          <tbody>
            <tr class="text-white">
              <th
                [ngClass]="getTableHeaderClass(formattedStatuses.get(key))"
                class="status-container__table__header text-white d-flex justify-content-between px-3"
              >
                <p class="d-flex align-items-center mb-0">{{ key }} Status</p>
                <button
                  class="breadcrumb-icon-button-item__icon-button flex-grow-0"
                  data-automation="ziro-breadcrumbs-about-card-toggle"
                  (click)="handleExpansionClick(i)"
                >
                  <span class="breadcrumb-icon-button-item__icon-button__icon-container text-white">
                    @if (!aboutCard.isExpanded) {
                      <i
                        [animate.enter]="'icon-toggle-enter'"
                        [animate.leave]="'icon-toggle-leave'"
                        [class]="ZiroIcons.ABOUT"
                        class="font-size-18"
                      ></i>
                    } @else {
                      <i
                        [animate.enter]="'icon-toggle-enter'"
                        [animate.leave]="'icon-toggle-leave'"
                        [class]="ZiroIcons.ABOUT_CLOSE"
                        class="font-size-18"
                      ></i>
                    }
                  </span>
                </button>
              </th>
            </tr>
            <ziro-about-card #aboutCard class="text-body flex-grow-1">
              @if (
                !!aboutCardTranslationKeys?.get(key)?.zpmTKey && !isNaN(aboutCardTranslationKeys?.get(key)?.zpmTKey)
              ) {
                <ziro-breadcrumb-card-item
                  [aboutCardId]="Number(aboutCardTranslationKeys?.get(key)?.zpmTKey)"
                ></ziro-breadcrumb-card-item>
              }
              @if (
                isNaN(Number(!!aboutCardTranslationKeys.get(key).zpcTKey)) ||
                isNaN(aboutCardTranslationKeys?.get(key)?.zpmTKey)
              ) {
                <div
                  [innerHTML]="
                    !!trafficStatus && !hostedEnabled
                      ? (aboutCardTranslationKeys.get(key).zpcTKey | escapeHtml)
                      : (aboutCardTranslationKeys?.get(key)?.zpmTKey | escapeHtml)
                  "
                ></div>
              }
            </ziro-about-card>
            @for (status of formattedStatuses.get(key); track status) {
              <tr
                class="d-flex status-container__table__row"
                [attr.data-automation]="
                  'system-status-result-' + key.toLowerCase().split(' ').join('-') + '-status-row'
                "
                [ngClass]="{
                  'table-warning': status?.state === stateEnum.WARNING,
                  'table-danger': status?.state === stateEnum.ERROR,
                }"
              >
                <td
                  class="col-sm-5 status-container__table__row__description"
                  [attr.data-automation]="
                    'system-status-result-' + key.toLowerCase().split(' ').join('-') + '-' + 'description'
                  "
                >
                  {{ status?.description }}
                </td>
                <td
                  class="col-sm-7 text-end status-container__table__row__status"
                  [attr.data-automation]="key.toLowerCase().split(' ').join('-') + '-' + 'status'"
                >
                  @if (!isRefreshing) {
                    <span
                      class="badge me-2"
                      [attr.data-automation]="
                        'system-status-result-' + key.toLowerCase().split(' ').join('-') + '-status-badge'
                      "
                      [style.max-width.px]="'maxWidth' in status ? status.maxWidth : undefined"
                      [ngClass]="{
                        'bg-warning': status?.state === stateEnum.WARNING,
                        'bg-danger': status?.state === stateEnum.ERROR,
                        'bg-success': status?.state === stateEnum.OK,
                        'status-container__table__row__error-message': 'tooltip' in status && !!status.tooltip,
                      }"
                    >
                      <div
                        [hidden]="!('tooltip' in status) || !status.tooltip"
                        data-automation="system-status-result-endpoints-status-text"
                        [ngbTooltip]=" 'tooltip' in status && status?.tooltip"
                        [tooltipClass]="'system-status-tooltip'"
                        [disableTooltip]="'errorCount' in status && status?.errorCount === 2"
                        [ngClass]="{ 'text-truncate': 'errorCount' in status && status?.errorCount > 1 }"
                      >
                        {{ status?.state === stateEnum.OK ? 'OK' : status?.cause }}
                      </div>
                      @if (!('tooltip' in status) || !status.tooltip) {
                        <span>
                          {{ status?.state === stateEnum.OK ? 'OK' : status?.cause }}
                        </span>
                      }
                    </span>
                  }
                  @if (isRefreshing) {
                    <i class="icon-saving"></i>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (!endpointsStatusExists && !!trafficStatus && trafficStatus?.state !== stateEnum.OK) {
      <div
        class="alert alert-warning d-flex align-items-center justify-content-center p-4"
        data-automation="system-status-result-alert"
      >
        <i class="{{ ziroIcons.WARNING_TRIANGLE }} fa-2x"></i>
        <h5 class="ms-2 mb-0" [innerHTML]="'tkey;system_status.server.unavailable' | escapeHtml"></h5>
      </div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
